/* eslint-disable import/no-unresolved */
import React from 'react';
import './style.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Grid } from 'swiper';
import { ArrowForwardSharp } from '@mui/icons-material';
import classNames from 'classnames';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import { Link } from 'gatsby-link';
import { getImageUrl } from '../../utils/helpers';

const Service = ({ service, divideVertically }) => (
  <div
    className={classNames({
      'flex flex-col gap-5': true,
      'lg:pb-20 md:pb-14 pb-0': divideVertically,
    })}
  >
    <img
      src={service.imageUrl}
      className='services__img'
      alt={service.name}
    />
    <h4 className='text-primary min-h-[50px] inline-flex items-center'>{service.name}</h4>
    <p className='p5 text-[#052A2D85] line-clamp-3'>{service.description}</p>
    <Link
      to={service.ctaLink}
      className='text-primary'
    >
      Learn more <ArrowForwardSharp />
    </Link>
  </div>
);

const mapServicesData = (data) =>
  data.map((service) => ({
    name: service.serviceName || '',
    description: service.description || '',
    imageUrl: getImageUrl(service.image.hash, 'w_192,h_192,c_fit'),
    ctaLink: service?.slug ? `/service/${service.slug}` : '/about-us',
  }));

function Services({ data, isGrid }) {
  const services = mapServicesData(data);

  const swiperBreakpoints = {
    100: {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'row',
      },
      spaceBetween: 0,
    },
    767: {
      slidesPerView: 2,
      grid: {
        rows: isGrid ? 2 : 1,
        fill: 'row',
      },
      spaceBetween: 20,
    },
    1020: {
      slidesPerView: 3,
      grid: {
        rows: isGrid ? 3 : 1,
        fill: 'row',
      },
      spaceBetween: 30,
    },
  };

  return (
    <section className='services__container'>
      <div className='srv__heading text-primary'>
        <h4 className='text-primary'>SERVICES</h4>
        <p className='lg:p2'>
          We offer a wide range of services to support your customer-facing operations. Our
          experienced agents can handle inbound and outbound calls, live chat, and email support. We
          also provide multilingual support, quality assurance, and data entry services.
        </p>
      </div>
      <hr className='bg-[#00053D1A] mt-5' />
      <Swiper
        breakpoints={swiperBreakpoints}
        pagination={{ clickable: true }}
        modules={[Grid, Pagination]}
        className='services__slider'
      >
        {services.map((service) => (
          <SwiperSlide className='slide__fit service-slide'>
            <Service
              service={service}
              divideVertically={isGrid}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default Services;
